export default "__VITE_ASSET__Bzeh9sG7__"